import axiosInstance from '../../../helpers/api';

export const getLessonsByChapterID = (id) => {
    return axiosInstance.get(`/students/lessons/${id}`);
};



